var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offer-book-appointment"},[_vm._t("offer-book-appointment",null,{"downloadPdf":_vm.downloadPdf})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }